import React, { useState } from 'react';
import { Button } from 'shards-react';
import { strings } from '../../localization';
import { EntypoBack } from 'react-entypo-icons';

const AddressSelection = ({
  organisationInfo,
  additionalAddresses,
  selectedAddressIndex,
  onSelectAddress,
  onClose
}) => {
  const [localSelectedIndex, setLocalSelectedIndex] = useState(selectedAddressIndex);

  const handleSave = () => {
    onSelectAddress(localSelectedIndex);
    onClose();
  };

  return (
    <div style={{   
      backgroundColor: '#fff', 
      width: '100%', 
      borderColor: '#999999', 
      borderWidth: 1, 
      // padding: 10,
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100vh - 100px)',
      borderRadius: '8px'
    }}>
      <p
        style={{ textAlign: 'center', fontSize: 22, paddingVertical: 8, margin: 0 }}
        className="mb-4"
        size="lg"
      >
        {strings.select_address}
      </p>

      <div className="list-group" style={{ flex: 1, overflowY: 'auto', paddingRight: '5px', marginBottom: '10px' }}>
        {/* Principal Address */}
        <div
          className="list-group-item mb-3 p-3 shadow-none hover-shadow"
          onClick={() => setLocalSelectedIndex(-1)}
          style={{ 
            cursor: 'pointer',
            borderRadius: '10px', 
            border: localSelectedIndex === -1 ? '2px solid #007bff' : '1px solid #dee2e6',
            backgroundColor: '#fff',
            transition: 'all 0.2s ease-in-out',
            position: 'relative' // For absolute positioning of radio
          }}
        >
          <div className="form-check mb-0" style={{ position: 'absolute', top: '15px', right: '15px' }}>
            <input 
              className="form-check-input" 
              type="radio" 
              name="addressSelect"
              id="addr-principal"
              checked={localSelectedIndex === -1}
              onChange={() => setLocalSelectedIndex(-1)}
              style={{ cursor: 'pointer', width: '22px', height: '22px', margin: 0 }}
            />
          </div>
          <div className="flex-grow-1" style={{ paddingRight: '35px' }}>
            <div className="text-muted" style={{ fontSize: '15px' }}>
              <p className="mb-1"><strong>{strings.address} :</strong> {(organisationInfo && organisationInfo.address) || '-'}</p>
              <p className="mb-1"><strong>{strings.city} :</strong> {(organisationInfo && organisationInfo.city) || '-'}</p>
              <p className="mb-0"><strong>{strings.state} :</strong> {(organisationInfo && organisationInfo.state) || '-'}</p>
            </div>
          </div>
        </div>
        
        {/* Additional Addresses */}
        {additionalAddresses && additionalAddresses.map((addr, index) => (
          <div
            key={index}
            className="list-group-item mb-3 p-3 shadow-none"
            onClick={() => setLocalSelectedIndex(index)}
            style={{ 
              cursor: 'pointer',
              borderRadius: '10px', 
              border: localSelectedIndex === index ? '2px solid #007bff' : '1px solid #dee2e6',
              backgroundColor: '#fff',
              transition: 'all 0.2s ease-in-out',
              position: 'relative' // For absolute positioning of radio
            }}
          >
            <div className="form-check mb-0" style={{ position: 'absolute', top: '15px', right: '15px' }}>
              <input 
                className="form-check-input" 
                type="radio" 
                name="addressSelect"
                id={`addr-${index}`}
                checked={localSelectedIndex === index}
                onChange={() => setLocalSelectedIndex(index)}
                style={{ cursor: 'pointer', width: '22px', height: '22px', margin: 0 }}
              />
            </div>
            <div className="flex-grow-1" style={{ paddingRight: '40px' }}>
              <div className="text-muted" style={{ fontSize: '15px' }}>
                <p className="mb-1"><strong>{strings.address} :</strong> {addr.address || '-'}</p>
                <p className="mb-1"><strong>{strings.city} :</strong> {addr.city || '-'}</p>
                <p className="mb-0"><strong>{strings.state} :</strong> {addr.state || '-'}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Static Footer */}
      <div className="mt-2 d-flex justify-content-between align-items-center p-2" style={{ borderTop: '1px solid #eee' }}>
        <div 
          onClick={onClose}
          style={{
            borderRadius: 60,
            backgroundColor: '#2e209b',
            padding: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 52,
            width: 52,
            cursor: 'pointer'
          }}
        >
          <EntypoBack style={{ color: 'white', height: '24px', width: '24px' }} />
        </div>
        <Button pill size='lg' theme="primary" style={{ width: '40%' }} onClick={handleSave}>
          {strings.select}
        </Button>
      </div>
    </div>
  );
};

export default AddressSelection;
